
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { RefreshCw } from "lucide-react";
import { TransformationCounter } from "@/components/TransformationCounter";
import { SubscriptionStatus } from "@/services/subscription";

interface SubscriptionStatusIndicatorProps {
  subscriptionStatus: SubscriptionStatus | null;
  onRefresh: () => void;
}

export const SubscriptionStatusIndicator = ({ 
  subscriptionStatus, 
  onRefresh 
}: SubscriptionStatusIndicatorProps) => {
  if (!subscriptionStatus) return null;
  
  return (
    <div className="flex justify-center items-center gap-2">
      <motion.div whileHover={{ scale: 1.05 }} transition={{ duration: 0.2 }}>
        <TransformationCounter 
          remainingTransforms={subscriptionStatus.remainingFreeTransforms} 
          isUnlimited={subscriptionStatus.isActive}
        />
      </motion.div>
      <Button 
        variant="ghost" 
        size="icon" 
        onClick={onRefresh} 
        title="Refresh subscription status"
        className="h-6 w-6"
      >
        <RefreshCw className="h-3 w-3" />
      </Button>
    </div>
  );
};
